import styled from 'styled-components';

export type InitialsAvatarSize = 'small' | 'large';

const DIMENSIONS: Record<InitialsAvatarSize, { diameter: string; fontSize: string }> = {
  small: { diameter: '30px', fontSize: '0.75rem' },
  large: { diameter: '56px', fontSize: '1.25rem' },
};

const Circle = styled.span<{ $size: InitialsAvatarSize }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => DIMENSIONS[$size].diameter};
  height: ${({ $size }) => DIMENSIONS[$size].diameter};
  border-radius: 50%;
  background: var(--color-accent-soft);
  color: var(--color-accent);
  font-size: ${({ $size }) => DIMENSIONS[$size].fontSize};
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
`;

const InitialsAvatarStyled = { Circle };

export default InitialsAvatarStyled;
